const Filters = {
	filters: {
		"purpose": "",
		"intervention-type": [],
		"type": [],
		"mechanism": [],
		"users": [],
		"decisionmakers": [],
		"level": []
	},
	get length(){
		let length = [];

		for(let key in this.filters) {
			if(!Array.isArray(this.filters[key])){
				length.push(this.filters[key].length == 0 ? 0 : 1);
			} else {
				length.push(this.filters[key].length);
			}
		}

		return length.reduce((a,b) => {return a + b}, 0);
	},
	getCurrentFilters(){
		let arr = [];

		for(let key in this.filters){
			if (this.filters[key].length > 0) {
				arr.push({key: key, value: this.filters[key]});
			}
		}
		return arr;
	},
	changeSingle(a, category) {
		if (a == "clear") { 
			this.filters[category] = "";
		} else {
			this.filters[category] = a;
		}
	},
	addToArray(value, category) {
		return this.filters[category].push(value);
	},
	removeFromArray(value,category){
		return this.filters[category].splice(this.filters[category].indexOf(value), 1);
	},
	clearAllFilters(){
		for (let key in this.filters){
			if (!Array.isArray(this.filters[key])) {
				this.filters[key] = "";
			} else {
				this.filters[key] = [];
			}
		}
	}
}

export { Filters };